<template>
  <component v-bind:is="component" class="navigation-wrapper is-hidden-print" />
</template>
<script>
import Navigation from '@/components/Navigation/_Navigation'
import AdacNavigation from '@/components/Navigation/Adac'

// const AdacNavigation = () => import(/* webpackPrefetch: true , webpackChunkName: "navigation" */ '@/components/Navigation/_Navigation')
// const Navigation = () => import(/* webpackPrefetch: true , webpackChunkName: "adac-navigation" */ '@/components/Navigation/Adac')

// wip wont work because fo Critical dependency: require function is used in a way in which dependencies cannot be statically extracted
//webpack is not able to extract if those are set dynamic ...
// const requireCustomFile = require.context('./components/Navigation', true, /(Adac.vue|_Navigation.vue)$/)
// const templateFileToUse = requireCustomFile.keys().sort()[0]
// const Navigation = requireCustomFile(templateFileToUse).default
export default {
  name: 'NavigationProxy',
  components: {
    Navigation,
    AdacNavigation,
  },
  props: {},
  computed: {
    component: function() {
      switch (this.$whitelabel.short) {
        case 'ADAC':
          return 'AdacNavigation'
        default:
          return 'Navigation'
      }
    },
  },
}
</script>
